<div class="btn-group fontify-13px" style="width:100%">
    <button type="button" class="btn btn-primary" (click)="clicked.emit()" [disabled]="disabled"
        style="width:100%; cursor: pointer;" [ngClass]="{'disabled': disabled}">
        <div style="display:flex; justify-content: flex-start; align-items: center;">
            <i class="fa-duotone fa-floppy-disk icon" style="font-size: 20px; margin-left:4px;" [ngClass]="{'disabled-icon': disabled}"></i>
            <div style="margin-left: 8px;">
                {{ selectedMode }}
            </div>
        </div>
    </button>
    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" (click)="toggleDropdown()"
        [disabled]="disabled" [ngClass]="{'disabled': disabled}">
        <div class="fas fa-chevron-down dropdown-toggle-icon" [ngClass]="{'disabled-icon': disabled}"></div>
    </button>
    <div class="dropdown-menu" [class.show]="dropdownOpen">
        <div *ngIf="mode !== 'review'" class="dropdown-item">
            <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="shouldAutoAdvance$ | async"
                (change)="toggleAutoAdvance($event)" style="margin-right: 15px;">Auto Advance</mat-checkbox>
        </div>
        <div class="dropdown-item">
            <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="shouldPropagateCoding$ | async"
                (change)="togglePropagateCoding($event)">Propagate Coding</mat-checkbox>
        </div>
    </div>
</div>